import React from 'react';
import LoadingSpinner from '../app_components/LoadingSpinner';

class BtnSecondary extends React.Component {
  render() {
    return (
      <button
        className="lex-btn lex-btn--secondary"
        onClick={() => this.props.onClick()}
        disabled={this.props.loading === true}
        aria-busy={this.props.loading === true}
      >
        {this.props.loading
          ? <LoadingSpinner size={22} variant="primary" />
          : this.props.buttonText}
      </button>
    );
  }
}

export default BtnSecondary;
